var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.retailDrawEvent)?_c('div',{staticClass:"waiting-for-draw"},[_c('FlagCategoryTournament',{attrs:{"is-row-view":"","event":_vm.retailDrawEvent,"font-size-not-default":"","flag-size":_vm.getFlagSize}}),_c('div',{staticClass:"draw-id"},[_vm._v(" "+_vm._s(_vm.translate('waitingForDrawNo', _vm.retailDrawEvent.lotteryDisplayId))+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }